var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4437 37.9976C19.1082 37.9976 18.776 37.9327 18.4661 37.8068C18.1563 37.6808 17.8749 37.4961 17.6382 37.2635L0.748406 20.734C0.269187 20.2645 0 19.628 0 18.9644C0 18.3007 0.269187 17.6642 0.748406 17.1947L17.6357 0.665269C18.121 0.22614 18.7611 -0.0121 19.4219 0.000473534C20.0826 0.0130471 20.7128 0.275458 21.1802 0.732718C21.6477 1.18998 21.9163 1.80659 21.9296 2.45334C21.9429 3.1001 21.6999 3.72679 21.2516 4.20209L6.16973 18.9644L21.2516 33.7266C21.609 34.0768 21.8524 34.5228 21.9509 35.0082C22.0495 35.4937 21.9988 35.9969 21.8054 36.4542C21.6119 36.9115 21.2843 37.3024 20.8639 37.5775C20.4436 37.8527 19.9493 37.9997 19.4437 38V37.9976Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.f319b0e5.svg";
export { ForwardRef as ReactComponent };